import { useShippingProductTypeService } from '../services/useShippingProductTypeService';
import { ShippingGeneralProductContainer } from './ShippingGeneralProductContainer';
import { ShippingPreOrderContainer } from './ShippingPreOrderContainer';
import { ShippingStoreZigzinProductContainer } from './ShippingStoreZigzinProductContainer';
import { ShippingZigzinProductContainer } from './ShippingZigzinProductContainer';

export interface ShippingInfoContainerProps {}

export const ShippingInfoContainer: React.FC<React.PropsWithChildren<ShippingInfoContainerProps>> = () => {
  const { isDigitalProduct, isPreorder, isGeneralProduct, isZigzinProduct, isStoreZigzin } =
    useShippingProductTypeService();

  if (isDigitalProduct) {
    return null;
  }

  if (isPreorder) {
    return <ShippingPreOrderContainer />;
  }

  if (isGeneralProduct) {
    return <ShippingGeneralProductContainer />;
  }

  if (isZigzinProduct) {
    return <ShippingZigzinProductContainer />;
  }

  if (isStoreZigzin) {
    return <ShippingStoreZigzinProductContainer />;
  }
  return null;
};
